'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('admanage', {
        url: '/admanage',
        template: '<admanage></admanage>'
    });
}



// WEBPACK FOOTER //
// ./client/app/admanage/admanage.routes.js